document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.brick-faq__trigger');

  if (!trigger) {
    return;
  }

  const item = trigger.closest('.brick-faq__item');
  const answer = document.getElementById(trigger.getAttribute('aria-controls'));

  if (!item || !answer) {
    return;
  }

  const isOpen = trigger.getAttribute('aria-expanded') === 'true';
  trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  answer.hidden = isOpen;
  item.classList.toggle('is-open', !isOpen);
});
